import * as _ from 'lodash';

import { ADD_CATEGORIES, CATEGORIES_ADD_CATEGORIES_FOR_USER, CategoriesAction, SET_CATEGORIES_LOADING } from '@Actions/categoriesActions';

import { ICompanyCategoryModel } from '@Shared/models';

interface ICategoriesState {
  activeCategories: ICompanyCategoryModel[];
  disabledCategories: ICompanyCategoryModel[];
  allCategories: ICompanyCategoryModel[];
  categoriesByUser: Record<string, ICompanyCategoryModel[]>;
  loading: boolean;
}

export const initialState: ICategoriesState = {
  activeCategories: [],
  disabledCategories: [],
  allCategories: [],
  categoriesByUser: {},
  loading: false
};

function filterWithSubcategories(categories: any[], filterCondition: (category: any) => boolean) {
  const filteredArray = [];
  for (const category of categories) {
    if (filterCondition(category)) {
      const copyCategory = { ...category };
      const filteredSubCategoryArray = [];
      if (category.subcategories) {
        for (const subcategory of category.subcategories) {
          if (filterCondition(subcategory)) {
            filteredSubCategoryArray.push(subcategory);
          }
        }
        copyCategory.subcategories = filteredSubCategoryArray;
      }
      filteredArray.push(copyCategory);
    }
  }
  return filteredArray;
}

export function categoriesReducer(state: ICategoriesState = initialState, action: CategoriesAction) {
  switch (action.type) {
    case ADD_CATEGORIES:
      return _.assign({}, state, {
        activeCategories: filterWithSubcategories(action.categories, (category) => category.enabled),
        disabledCategories: action.categories.filter((category) => !category.enabled),
        allCategories: action.categories
      });
    case SET_CATEGORIES_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case CATEGORIES_ADD_CATEGORIES_FOR_USER:
      return {
        ...state,
        categoriesByUser: { ...state.categoriesByUser, [action.payload.userId]: action.payload.categories }
      };
    default:
      return state;
  }
}
